import TaskInfo from './task_info';

export default TaskInfo;
